import { PaymentMethod as GqlPaymentMethod } from '@willow/graphql-iso/src/app';
import { AchPaymentMethods, assertNever, NonAchPaymentMethods, PaymentMethod } from '@willow/types-iso';

export function gqlToIsoPaymentMethod(method: GqlPaymentMethod): PaymentMethod {
  switch (method) {
    case GqlPaymentMethod.Check:
      return 'check';
    case GqlPaymentMethod.Wire:
      return 'wire';
    case GqlPaymentMethod.Phone:
      return 'phone';
    case GqlPaymentMethod.Dwolla:
      return 'dwolla';
    case GqlPaymentMethod.Reversal:
      return 'reversal';
    case GqlPaymentMethod.Reserve:
      return 'reserve';
    case GqlPaymentMethod.ReserveReversal:
      return 'reserveReversal';
    case GqlPaymentMethod.BalanceForward:
      return 'balanceForward';
    case GqlPaymentMethod.PrincipalPrepayment:
      return 'principalPrepayment';
    case GqlPaymentMethod.AuthorizedAch:
      return 'authorizedACH';
    case GqlPaymentMethod.BalanceReallocation:
      return 'balanceReallocation';
    case GqlPaymentMethod.CreditCard:
      return 'creditCard';
    case GqlPaymentMethod.DebitCard:
      return 'debitCard';
    case GqlPaymentMethod.Lockbox:
      return 'lockbox';
    default:
      assertNever(method);
  }
}

// convertEnumToGqlEnum isnt working with "Ach"
export const isoToGqlPaymentMethod = (method: PaymentMethod): GqlPaymentMethod => {
  switch (method) {
    case 'check':
      return GqlPaymentMethod.Check;
    case 'wire':
      return GqlPaymentMethod.Wire;
    case 'phone':
      return GqlPaymentMethod.Phone;
    case 'creditCard':
      return GqlPaymentMethod.CreditCard;
    case 'debitCard':
      return GqlPaymentMethod.DebitCard;
    case 'dwolla':
      return GqlPaymentMethod.Dwolla;
    case 'reversal':
      return GqlPaymentMethod.Reversal;
    case 'reserve':
      return GqlPaymentMethod.Reserve;
    case 'reserveReversal':
      return GqlPaymentMethod.ReserveReversal;
    case 'balanceForward':
      return GqlPaymentMethod.BalanceForward;
    case 'principalPrepayment':
      return GqlPaymentMethod.PrincipalPrepayment;
    case 'authorizedACH':
    case 'repayACH':
      return GqlPaymentMethod.AuthorizedAch;
    case 'balanceReallocation':
      return GqlPaymentMethod.BalanceReallocation;
    case 'lockbox':
      return GqlPaymentMethod.Lockbox;
    default:
      assertNever(method);
  }
};

export const isNonAchPaymentMethod = (paymentMethod: PaymentMethod): boolean =>
  NonAchPaymentMethods.safeParse(paymentMethod).success;

export const isAchPaymentMethod = (paymentMethod: PaymentMethod): boolean =>
  AchPaymentMethods.safeParse(paymentMethod).success;
